import { Column } from 'material-table';

import { getTableColumn } from '../../../../shared/operators';
import { ClassificationModel } from '../../../../Models/ClassificationModel';
import { CategoryModelFullDto } from '../../../../Models/CategoryModelFullDto';

export enum InformationToCorrect {
    JOURNALIST = 0,
    LOCALIZATION,
    VEHICLE,
    COVER_PRESENCE,
    EXPOSITION,
    ORGANOGRAM,
    EXTRA_PARAMETER,
    SPOTLIGHT,
    CONTENT,
    SOURCE,
    KEYWORD
}

export interface IInformationToCorrect {
    description: string,
    value: InformationToCorrect,
    column: Column<ClassificationModel | CategoryModelFullDto>
}

export const informationToCorrectInitialArray: IInformationToCorrect[] = [
    {
        description: 'Jornalista',
        value: InformationToCorrect.JOURNALIST,
        column: getTableColumn('Jornalista', 'journalistsNames', 'string','left', { minWidth: '150px' })
    },
    {
        description: 'Localização',
        value: InformationToCorrect.LOCALIZATION,
        column: getTableColumn('Localização', 'location.name', 'string', 'left', { minWidth: '100px' })
    },
    {
        description: 'Veículo',
        value: InformationToCorrect.VEHICLE,
        column: getTableColumn('Veículo', 'vehicleNomenclature', 'string', 'left', { minWidth: '150px' })
    },
    {
        description: 'Presença na capa',
        value: InformationToCorrect.COVER_PRESENCE,
        column: getTableColumn('Presença na capa', 'coverPresence.name', 'string', 'left', { minWidth: '100px' })
    },
    {
        description: 'Recursos multimídia',
        value: InformationToCorrect.EXPOSITION,
        column: getTableColumn('Recursos multimídia', 'expositionsDescription', 'string','left', { minWidth: '150px' })
    },
    {
        description: 'Organograma',
        value: InformationToCorrect.ORGANOGRAM,
        column: getTableColumn('Organograma', 'organogram', 'string', 'left', { minWidth: '150px' })
    },
    {
        description: 'Análise de mensagem chave',
        value: InformationToCorrect.EXTRA_PARAMETER,
        column: getTableColumn('Análise de mensagem chave', 'extraParametersAnswers', 'string', 'left', { minWidth: '100px' })
    },
    {
        description: 'Destaque',
        value: InformationToCorrect.SPOTLIGHT,
        column: getTableColumn('Destaque', 'spotlightName', 'string', 'left', { minWidth: '100px' })
    },
    {
        description: 'Teor',
        value: InformationToCorrect.CONTENT,
        column: getTableColumn('Teor', 'contentName', 'string', 'left', { minWidth: '100px' })
    },
    {
        description: 'Fonte',
        value: InformationToCorrect.SOURCE,
        column: getTableColumn('Fontes', 'sources', 'string', 'left', { minWidth: '150px' })
    },
    {
        description: 'Palavras-chave',
        value: InformationToCorrect.KEYWORD,
        column: getTableColumn('Palavras-chave', 'keywords', 'string', 'left', { minWidth: '250px' })
    }
];
